import React from 'react';
import './textPodkova.scss';

interface IPodTextProps {
  text?: string;
  type?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4';
  className ?:string;
}

export const PodTextS75W500= ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s75w500-fontPod">{text}</Component>;
};

export const PodTextS90W400 = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s90w400-fontPod">{text}</Component>;
};

export const PodTextS60W400 = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s60w400-fontPod">{text}</Component>;
};

export const PodTextS50W400 = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s50w400-fontPod">{text}</Component>;
};


export const PodTextS30W400= ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s30w400-fontPod">{text}</Component>;
}

export const PodTextS30W500Lh400= ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s30w500lh40-fontPod">{text}</Component>;
}

export const PodTextS40W400Lh40 = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s40w400lh40-fontPod">{text}</Component>;
}


export const PodTextS40W400Lh40Ls1Minus = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s40w400lh40ls1mius-fontPod">{text}</Component>;
}


export const PodTextS15W400Lh25Ls05= ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s15w400lh25ls0_5-fontPod">{text}</Component>;
  }

  
export const PodTextS16W500Lh30= ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s16w500lh30-fontPod">{text}</Component>;
}

export const PodTextS18W600Lh18White= ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s18w600lh18white-fontPod">{text}</Component>;
}



  export const PodTextS110W400Lh120Ls4_= ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s110w400lh120ls4minus-fontPod">{text}</Component>;
  }


  export const PodTextS110W400Lh70Ls4_= ({ text, type = 'div',className = '' }: IPodTextProps) => {
    const Component = type;
    const classes = `s110w400lh70ls4minus-fontPod ${className}`;
  
    return <Component className={classes.trim()}>{text}</Component>;
  }